import { registerArtifactPayload } from '@/features/documentPreview/artifactPayloadStore'
import { NEXUS_CRM_INTEGRATION_ARTIFACT_FILE_NAME } from './nexusIntegrationsDemo.js'
import {
  ZOHO_CRM_INTEGRATION_THOUGHT_DETAILS,
  ZOHO_CRM_INTEGRATION_USER_PROMPT,
  buildZohoCrmIntegrationArtifactPayload,
  buildZohoCrmIntegrationFinalBlocks,
} from './zohoCrmIntegrationDemoContent.js'

export const ZOHO_CRM_INTEGRATION_DEMO_ARTIFACT_ID = 'artifact-demo-zoho-crm-integration'

/** Shared chat render speed — 3× faster than baseline. */
export { CHAT_STREAM_SPEED_FACTOR as ZOHO_DEMO_STREAM_SPEED_FACTOR } from '../streaming/chatStreamSpeed.js'

/** Random thinking / step pauses (ms) — avoids a fixed 3s everywhere. */
export const ZOHO_STREAM_THINKING_PAUSE_MS = [2000, 3000, 4000, 6000]

export function ensureZohoCrmIntegrationArtifactRegistered() {
  registerArtifactPayload({
    artifactId: ZOHO_CRM_INTEGRATION_DEMO_ARTIFACT_ID,
    kind: 'doc',
    fileName: NEXUS_CRM_INTEGRATION_ARTIFACT_FILE_NAME,
    description: 'Markdown',
    payload: buildZohoCrmIntegrationArtifactPayload(),
  })
}

/** @returns {object[]} */
export function buildZohoCrmIntegrationDemoFinalAssistantBlocks() {
  return buildZohoCrmIntegrationFinalBlocks(ZOHO_CRM_INTEGRATION_DEMO_ARTIFACT_ID)
}

export { ZOHO_CRM_INTEGRATION_USER_PROMPT, ZOHO_CRM_INTEGRATION_THOUGHT_DETAILS }
